import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthProviderFactory } from '../auth/auth-provider.factory';
import { AppConfigService } from '../app-config.service';
import { authClientForUrl } from '@web/shared-functions/auth';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const factory = inject(AuthProviderFactory);
  const config = inject(AppConfigService);
  const router = inject(Router);

  const keycloakUrl = config.get().auth.clients;
  const isKeycloakRequest = Object.values(keycloakUrl).some(client =>
    req.url.includes(client.issuer)
  );

  if (isKeycloakRequest) {
    return next(req);
  }

  const token = factory
    .getProvider(authClientForUrl(router.url))
    .getAccessToken();

  if (token) {
    // eslint-disable-next-line no-param-reassign
    req = req.clone({
      setHeaders: { Authorization: `Bearer ${token}` },
    });
  }
  return next(req);
};
